import React from 'react';
import { Navigate } from 'react-router-dom';
import AllInboxOutlinedIcon from '@mui/icons-material/AllInboxOutlined';
import { lazyPage } from '../lazyPage';

const UnifiedInbox = lazyPage(() => import(/* webpackChunkName: "m-inbox" */ './pages/UnifiedInboxPage'));

/**
 * Unified Inbox — one channel-agnostic view over the conversations/messages store
 * (dealer/Wati today; agronomist/Gupshup + FarmGPT as they migrate). Additive: the
 * legacy chat surfaces stay mounted until they're folded in. Gated by the same
 * feature as the dealer chat; the backend scopes rows (dealer=own, admin=all).
 */
const inboxManifest = {
    id: 'unified-inbox',
    // Visible to a dealer (their own Wati chats) AND to an oversight role like ops
    // (gptChat_mgmt View = read-only "see all chats"). viewPermission grants on ANY.
    featureName: ['wati_chat_mgmt', 'gptChat_mgmt'],
    permission: 'view',
    routes: [
        { path: '/inbox', element: <UnifiedInbox /> },
        // Redirect the retired chat routes to the unified Inbox so old bookmarks,
        // cached bundles, and the dealer's WhatsApp deep links don't land on a blank
        // page. '/chats' = old dealer chat page; '/user-chat' = old FarmGPT monitor.
        { path: '/chats', element: <Navigate to="/inbox" replace /> },
        { path: '/user-chat', element: <Navigate to="/inbox" replace /> },
    ],
    sidebarItems: [{ text: 'Inbox', icon: <AllInboxOutlinedIcon />, link: '/inbox' }],
};

export default inboxManifest;
